import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__ from "./pricing-context.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__pricing_card_mjs_2900db3a__ from "./pricing-card.mjs";
const FeatureGate = ({ featureKey, children, type = "modal", disabled, modalProps })=>{
    const { hasFeature, plans, currentPlan, subscription, openFeatureGateDialog } = (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.usePricing)();
    const hasAccess = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>hasFeature(featureKey) || disabled, [
        hasFeature,
        featureKey,
        disabled
    ]);
    const handleModalOpen = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        openFeatureGateDialog({
            featureKey,
            onOpen: modalProps?.onModalOpen,
            onClose: modalProps?.onModalClose,
            className: modalProps?.className
        });
    }, [
        featureKey,
        modalProps,
        openFeatureGateDialog
    ]);
    if (hasAccess) return children;
    const featureLabel = plans.flatMap((p)=>p.features).find((f)=>f.key === featureKey)?.label || featureKey;
    if ("fullscreen" === type) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "relative min-h-screen",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "absolute inset-0 overflow-hidden",
                inert: "",
                onClickCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                onMouseDownCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                onMouseUpCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                onKeyDownCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                onFocusCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                onSubmitCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                style: {
                    pointerEvents: "none"
                },
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    className: "pointer-events-none select-none",
                    "aria-hidden": "true",
                    children: children
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "absolute z-40 -inset-2 backdrop-blur-sm bg-grayscale-darkest/[0.75]"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "flex flex-col gap-10 relative z-50 min-h-screen items-center justify-start p-8 shadow-sm",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "flex flex-col items-center text-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("h2", {
                                className: "text-2xl md:text-3xl",
                                children: [
                                    "Upgrade to access ",
                                    featureLabel
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                                className: "text-xl text-secondary-foreground",
                                children: currentPlan ? `Your current plan (${currentPlan.title}) doesn't include this feature` : "Choose a plan to unlock this feature"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "max-w-7xl w-full",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__pricing_card_mjs_2900db3a__.PricingGrid, {
                            pricing: {
                                plans,
                                subscription: {
                                    priceIds: subscription?.stripePriceIds || []
                                }
                            },
                            options: {
                                filterByFeature: featureKey
                            }
                        })
                    })
                ]
            })
        ]
    });
    if ("modal" === type) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "relative cursor-pointer",
        onClickCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            handleModalOpen();
        },
        onMouseDownCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        },
        onMouseUpCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        },
        onKeyDownCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            handleModalOpen();
        },
        onFocusCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        },
        onSubmitCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            handleModalOpen();
        },
        children: children
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "cursor-not-allowed opacity-50",
        children: children
    });
};
export { FeatureGate };
